export * from './tabs.constants';
export * from './hot-sale.constants';